import React from 'react';
import './SiteCopyrightBar.css';

export const getFooterCopyrightText = () =>
  `© ${new Date().getFullYear()} Canadawale Yar™ ( CWY ). All rights reserved.`;

/** Centered copyright strip — shown on all pages except home (full footer there). */
export const SiteCopyrightBar: React.FC = () => (
  <div className="site-copyright-bar">
    <p className="site-copyright-bar__text">{getFooterCopyrightText()}</p>
  </div>
);
